import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import swal from "sweetalert"
import { useAppDispatch } from "../../app/hooks"
import { addressChange } from "../../store/parcel.store"

const AddressChangeModal = ({
    show,
    handleClose,
    data
}: {
    show: string
    handleClose: () => void
    data: Record<string, any>
}) => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [showError, setShowError] = useState<boolean>(false)
    const [disableAddParcel, setDisableAddParcel] = useState<boolean>(false)

    const dispatch = useAppDispatch()
    const [parcelDetails, setParcelDetails] = useState({
        address: "",
        id: ""
    })
    const checkAllRequiredFields = () => {
        if (parcelDetails.address && parcelDetails.address !== "") {
            setDisableAddParcel(false)
        } else {
            setDisableAddParcel(true)
        }
    }

    useEffect(() => {
        checkAllRequiredFields()
    }, [parcelDetails.address])

    useEffect(() => {
        if (data && Object.keys(data).length !== 0) {
            var parcelData = {
                address: data?.ParcelAddress?.address ? data?.ParcelAddress?.address : "",
                id: data.id
            }
            setParcelDetails(parcelData)
        }
    }, [data.id])

    const addParcelDetail = async (edit: boolean) => {
        var purchased: any = await dispatch(addressChange(parcelDetails))
        if (purchased?.payload?.data && purchased?.payload?.data?.status === true) {
            setLoading(false)
            swal({
                title: "",
                text: t("Address_Changed"),
                icon: "success"
            }).then(function () {
                handleClose()
            })
        } else {
            swal({
                title: "",
                text: t("Address_not_Changed"),
                icon: "error"
            }).then(function () {
                handleClose()
            })
        }
    }
    const handleCreateParcel = async (e: any) => {
        setLoading(true)
        addParcelDetail(true)
    }
    return (
        <Modal
            show={show === "changeAddress"}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("Parcel Address Change")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>{t("Address_Change_description")}</div>
                <Form noValidate className="form">
                    <Form.Group className="mt-2" controlId="awb">
                        <Form.Label column md="4" sm="2">
                            {t("New Address")}
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("New Address")}
                            name="address"
                            required={true}
                            value={parcelDetails?.address}
                            onChange={(e: any) =>
                                setParcelDetails({ ...parcelDetails, [e.target.name]: e.target.value })
                            }
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading || disableAddParcel}
                    id="btn-primary"
                    className="btn btn-primary"
                    type="submit"
                    onClick={handleCreateParcel}>
                    {" "}
                    {loading ? <div className="spinner-border text-light" role="status"></div> : t("Save")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddressChangeModal
